module.exports = __webpack_public_path__ + "static/virtual-reality-stem-cell-reprogramming-lenti-retrovirus-93a3c51b772f63bb550451a69297f077.jpg";